import { Badge } from "@mantine/core"
import { useTranslation } from "react-i18next"

interface Props {
  type: string | null | undefined
  /** Kept for call-site compatibility. */
  size?: unknown
}

/** Neutral outline pill «Агуулах → Жолооч» (canvas Ord_HandoverDetail). */
export function TransferTypeBadge({ type }: Props) {
  const { t } = useTranslation("delivery")
  if (!type) return <>-</>
  return (
    <Badge size="lg" variant="outline" color="gray" radius="xl" tt="none" fw={500} c="var(--nw-text)">
      {t(`custody.transferTypeBadge.${type}`, { defaultValue: "-" })}
    </Badge>
  )
}
